import React from 'react';
import { styled } from '@mui/material/styles';
import { useTheme } from '../../hooks/useTheme';
import { ViewProps } from './model';
import { buildImageSources } from './utils';

const StyledImg = styled('img')({
  verticalAlign: 'middle',
});
export const ViewNormal: React.FC<ViewProps> = ({ assetItem, responsiveGrid, alt, loading, fetchPriority, ...imgProps }) => {
  const theme = useTheme();
  const sources = buildImageSources(assetItem, responsiveGrid, theme);

  const sizes = React.useMemo(() => {
    if (!responsiveGrid || Object.keys(responsiveGrid).length === 0) {
      return '100vw';
    }

    const sortedBreakpoints = Object.entries(responsiveGrid).sort(
      (a, b) => theme.breakpoints.values[a[0]] - theme.breakpoints.values[b[0]],
    );

    return sortedBreakpoints
      .map(([breakpoint, width]) => {
        const screenWidth = theme.breakpoints.values[breakpoint];
        if (breakpoint === 'xs') {
          return `(max-width: ${screenWidth}px) ${width}px`;
        }
        const prevBreakpoint = sortedBreakpoints[sortedBreakpoints.indexOf([breakpoint, width]) - 1];
        const prevScreenWidth = prevBreakpoint ? theme.breakpoints.values[prevBreakpoint[0]] : 0;
        return `(min-width: ${prevScreenWidth + 1}px) ${width}px`;
      })
      .join(', ');
  }, [responsiveGrid, theme.breakpoints.values]);

  return (
    <picture>
      {sources.map((sourcesProps) => (
        <source key={[sourcesProps.srcSet, sourcesProps.media].join('|')} {...sourcesProps} />
      ))}
      <StyledImg alt={alt} fetchPriority={fetchPriority} loading={loading} sizes={sizes} {...imgProps} />
    </picture>
  );
};
